import React from "react";
import { Checkbox, Dropdown, Form, Header, Input } from "semantic-ui-react";

import { ApplePayButtonColorEnumsObj } from "@payair/apple-pay-sdk/enums/ApplePayButtonColorEnum"
import { ApplePayButtonTypeEnumsObj } from "@payair/apple-pay-sdk/enums/ApplePayButtonTypeEnum"

import { RootState, getArrayFromEnum } from "../../store/SrciStore";
import * as action from "../../store/reducers/ApplePayInputData";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import ArrayToUiList from "../../helpers/ArrayToUIList";

export default function ApplePay(this: any) {

  const commonDateFormat = "MM.DD.YYYY"

  const supportedCountries = ArrayToUiList(["GB", "SE", "PL"])

  const shippingContactEditingMode = [
    { key: "enabled", text: "enabled", value: "enabled" },
    { key: "storePickup", text: "storePickup", value: "storePickup" },
    { key: "undefined", text: "undefined", value: "undefined" }
  ]

  const shippingType = [
    { key: "shipping", text: "shipping", value: "shipping" },
    { key: "delivery", text: "delivery", value: "delivery" },
    { key: "storePickup", text: "storePickup", value: "storePickup" },
    { key: "servicePickup", text: "servicePickup", value: "servicePickup" },
    { key: "undefined", text: "undefined", value: "undefined" }
  ]

  const merchantCapabilities = [
    { key: "supports3DS", text: "supports3DS", value: "supports3DS" },
    { key: "supportsEMV", text: "supportsEMV", value: "supportsEMV" },
    { key: "supportsCredit", text: "supportsCredit", value: "supportsCredit" },
    { key: "supportsDebit", text: "supportsDebit", value: "supportsDebit" },
    { key: "undefined", text: "undefined", value: "undefined" }
  ]

  const requiredBillingContactFields = [
    { key: "email", text: "email", value: "email" },
    { key: "name", text: "name", value: "name" },
    { key: "phone", text: "phone", value: "phone" },
    { key: "postalAddress", text: "postalAddress", value: "postalAddress" },
    { key: "phoneticName", text: "phoneticName", value: "phoneticName" },
    { key: "undefined", text: "undefined", value: "undefined" },
  ]

  const requiredShippingContactFields = [
    { key: "email", text: "email", value: "email" },
    { key: "name", text: "name", value: "name" },
    { key: "phone", text: "phone", value: "phone" },
    { key: "postalAddress", text: "postalAddress", value: "postalAddress" },
    { key: "phoneticName", text: "phoneticName", value: "phoneticName" },
    { key: "undefined", text: "undefined", value: "undefined" },
  ]

  const supportedNetworks = [
    { key: "visa", text: "visa", value: "visa" },
    { key: "mastercard", text: "mastercard", value: "mastercard" },
    { key: "undefined", text: "undefined", value: "undefined" }
  ]

  const srcApplePayButtonColorEnumsObj = getArrayFromEnum(ApplePayButtonColorEnumsObj)
  const srcApplePayButtonTypeEnumsObj = getArrayFromEnum(ApplePayButtonTypeEnumsObj)

  const applepayInputs = useAppSelector((state: RootState) => state.applepayInputData)
  const appleInputs = useAppSelector((state: RootState) => state.applepayInputData.appleInputs)
  const applePayInitParams = useAppSelector((state: RootState) => state.applepayInputData.applePayInitParams)
  const billingAddress = useAppSelector((state: RootState) => state.srciInputData.dcfCheckoutParams.consumer)
  const dispatch = useAppDispatch()

  const handleOnChange = (e: any, element: any) => {
    if(element.type === "checkbox") {
      element.value = element.checked
    }

    dispatch(action.save({
      name: element.name,
      value: element.value
    }))
  }

  return (
    <React.Fragment>
      <Form>
        <Header as="h2">Apple Pay Inputs</Header>
        <Form.Group widths='equal'>
            <Form.Field>
                <label>Application Data</label>
                <Input value={applePayInitParams.applePayPaymentRequest?.applicationData} name="applePayInitParams.applePayPaymentRequest.applicationData" onChange={handleOnChange} />
            </Form.Field>
            <Form.Select fluid label="Shipping Contact Editing Mode" options={shippingContactEditingMode} name="applePayInitParams.applePayPaymentRequest.shippingContactEditingMode" defaultValue={applePayInitParams.applePayPaymentRequest?.shippingContactEditingMode} onChange={handleOnChange} />
            <Form.Select fluid label="Shipping Type" options={shippingType} defaultValue={applePayInitParams.applePayPaymentRequest?.shippingType} name="applePayInitParams.applePayPaymentRequest.shippingType" onChange={handleOnChange} />
            <Form.Field>
                <label>Supported Countries</label>
                <Dropdown fluid multiple selection options={supportedCountries} defaultValue={appleInputs.supportedCountries} name="appleInputs.supportedCountries" onChange={handleOnChange} />
            </Form.Field>                               
        </Form.Group>

        <Form.Group widths='equal'>
            <Form.Field>
                <label>Merchant Capabilities</label>
                <Dropdown fluid multiple selection options={merchantCapabilities} defaultValue={applePayInitParams.applePayPaymentRequest?.merchantCapabilities} name="applePayInitParams.applePayPaymentRequest.merchantCapabilities" onChange={handleOnChange} />
            </Form.Field>      
            <Form.Field>
                <label>Required Billing Contact Fields</label>
                <Dropdown fluid multiple selection options={requiredBillingContactFields} defaultValue={applePayInitParams.applePayPaymentRequest?.requiredBillingContactFields} name="applePayInitParams.applePayPaymentRequest.requiredBillingContactFields" onChange={handleOnChange} />
            </Form.Field>      
            <Form.Field>
                <label>Required Shipping Contact Fields</label>
                <Dropdown fluid multiple selection options={requiredShippingContactFields} defaultValue={applePayInitParams.applePayPaymentRequest?.requiredShippingContactFields} name="applePayInitParams.applePayPaymentRequest.requiredShippingContactFields" onChange={handleOnChange} />
            </Form.Field> 
            <Form.Field>
                <label>Supported Networks</label>
                <Dropdown fluid multiple selection options={supportedNetworks} defaultValue={applePayInitParams.applePayPaymentRequest?.supportedNetworks} name="applePayInitParams.applePayPaymentRequest.supportedNetworks" onChange={handleOnChange} />
            </Form.Field>                      
        </Form.Group>  

        <Form.Group widths='equal'>
            <Form.Field>
                <Checkbox label="Use Shipping Methods" checked={appleInputs.useShippingMethods} name="appleInputs.useShippingMethods" onChange={handleOnChange} />
            </Form.Field>                  
            <Form.Field>
                <Checkbox label="Use Billing Address" checked={appleInputs.useBillingAddress} name="appleInputs.useBillingAddress" onChange={handleOnChange} />
            </Form.Field>                  
            <Form.Field>
                <Checkbox label="Use Shipping Address" checked={appleInputs.useShippingAddress} name="appleInputs.useShippingAddress" onChange={handleOnChange} />
            </Form.Field>     
            <Form.Field></Form.Field>                         
        </Form.Group>   


        <Header as="h2">Billing & Shipping Address</Header>
        <Form.Group widths={"equal"}>
          <Form.Field>
            <label>Email address</label>
            <Input value={billingAddress.emailAddress} name="applePayInitParams.applePayPaymentRequest.billingContact.emailAddress" onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Family name</label>
            <Input value={billingAddress.firstName} name="applePayInitParams.applePayPaymentRequest.billingContact.familyName" onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Given name</label>
            <Input value={billingAddress.lastName} name="applePayInitParams.applePayPaymentRequest.billingContact.givenName" onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Phone number</label>
            <Input value={applePayInitParams.applePayPaymentRequest?.billingContact?.phoneNumber} name="applePayInitParams.applePayPaymentRequest.billingContact.phoneNumber" onChange={handleOnChange} />
          </Form.Field>                    
        </Form.Group>
        <Form.Group widths={"equal"}>
          <Form.Field>
            <label>Phonetic Family Name</label>
            <Input value={applePayInitParams.applePayPaymentRequest?.billingContact?.phoneticFamilyName} name="applePayInitParams.applePayPaymentRequest.billingContact.phoneticFamilyName" onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Phonetic Given Name</label>
            <Input value={applePayInitParams.applePayPaymentRequest?.billingContact?.phoneticGivenName} name="applePayInitParams.applePayPaymentRequest.billingContact.phoneticGivenName" onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Address Lines</label>
            <Input value={applePayInitParams.applePayPaymentRequest?.billingContact?.addressLines} name="applePayInitParams.applePayPaymentRequest.billingContact.addressLines" onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Locality</label>
            <Input value={applePayInitParams.applePayPaymentRequest?.billingContact?.locality} name="applePayInitParams.applePayPaymentRequest.billingContact.locality" onChange={handleOnChange} />
          </Form.Field>                    
        </Form.Group>  
        <Form.Group widths={"equal"}>
          <Form.Field>
            <label>Sub Locality</label>
            <Input value={applePayInitParams.applePayPaymentRequest?.billingContact?.subLocality} name="applePayInitParams.applePayPaymentRequest.billingContact.subLocality" onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Administrative Area</label>
            <Input value={applePayInitParams.applePayPaymentRequest?.billingContact?.administrativeArea} name="applePayInitParams.applePayPaymentRequest.billingContact.administrativeArea" onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Sub Administrative Area</label>
            <Input value={applePayInitParams.applePayPaymentRequest?.billingContact?.subAdministrativeArea} name="applePayInitParams.applePayPaymentRequest.billingContact.subAdministrativeArea" onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Postal Code</label>
            <Input value={applePayInitParams.applePayPaymentRequest?.billingContact?.postalCode} name="applePayInitParams.applePayPaymentRequest.billingContact.postalCode" onChange={handleOnChange} />
          </Form.Field>                    
        </Form.Group>       
        <Form.Group widths={"equal"}>
          <Form.Field>
            <label>Country</label>
            <Input value={applePayInitParams.applePayPaymentRequest?.billingContact?.country} name="applePayInitParams.applePayPaymentRequest.billingContact.country" onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Country Code</label>
            <Input value={applePayInitParams.applePayPaymentRequest?.billingContact?.countryCode} name="applePayInitParams.applePayPaymentRequest.billingContact.countryCode" onChange={handleOnChange} />
          </Form.Field>
        </Form.Group>                 

        <Header as="h2">Line Item #1</Header>
        <Form.Group widths={"equal"}>
          <Form.Field>
            <label>Amount</label>
            <Input value={appleInputs.lineItems[0].amount} name="appleInputs.lineItems[0].amount" onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Deferred Payment Date</label>
            <Input onChange={handleOnChange} value={appleInputs.lineItems[0].deferredPaymentDate} placeholder={commonDateFormat} name="appleInputs.lineItems[0].deferredPaymentDate" />
          </Form.Field>
          <Form.Field>
            <label>Label</label>
            <Input name="appleInputs.lineItems[0].label" value={appleInputs.lineItems[0].label} onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Payment Timing</label>
            <Input name="appleInputs.lineItems[0].paymentTiming" value={appleInputs.lineItems[0].paymentTiming} onChange={handleOnChange} />
          </Form.Field>                    
        </Form.Group>
        <Form.Group widths={"equal"}>
          <Form.Field>
            <label>Recurring Payment End Date</label>
            <Input onChange={handleOnChange} value={appleInputs.lineItems[0].recurringPaymentEndDate} name="appleInputs.lineItems[0].recurringPaymentEndDate" placeholder={commonDateFormat} />
          </Form.Field>
          <Form.Field>
            <label>Recurring Payment Interval Count</label>
            <Input name="appleInputs.lineItems[0].recurringPaymentIntervalCount" value={appleInputs.lineItems[0].recurringPaymentIntervalCount} onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Recurring Payment Interval Unit</label>
            <Input name="appleInputs.lineItems[0].recurringPaymentIntervalUnit" value={appleInputs.lineItems[0].recurringPaymentIntervalUnit} onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Recurring Payment Start Date</label>
            <Input name="appleInputs.lineItems[0].recurringPaymentStartDate" value={appleInputs.lineItems[0].recurringPaymentStartDate} onChange={handleOnChange} placeholder={commonDateFormat} />
          </Form.Field>                    
        </Form.Group>    
        <Form.Group widths={"equal"}>
          <Form.Field>
            <label>Type</label>
            <Input name="appleInputs.lineItems[0].type" value={appleInputs.lineItems[0].type} onChange={handleOnChange} />
          </Form.Field>
        </Form.Group>               

        <Header as="h2">Shipping Method #1</Header>
        <Form.Group widths={"equal"}>
          <Form.Field>
            <label>Amount</label>
            <Input name="appleInputs.shippingMethods[0].amount" value={appleInputs.shippingMethods[0].amount} onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Start Date Components</label>
            <Input name="appleInputs.shippingMethods[0].dateComponentsRange.startDateComponents" value={appleInputs.shippingMethods[0].dateComponentsRange?.startDateComponents} onChange={handleOnChange} placeholder={commonDateFormat} />
          </Form.Field>
          <Form.Field>
            <label>End Date Components</label>
            <Input name="appleInputs.shippingMethods[0].dateComponentsRange.endDateComponents" value={appleInputs.shippingMethods[0].dateComponentsRange?.endDateComponents} onChange={handleOnChange} placeholder={commonDateFormat} />
          </Form.Field> 
          <Form.Field>
            <label>Detail</label>
            <Input name="appleInputs.shippingMethods[0].detail" value={appleInputs.shippingMethods[0].identifier} onChange={handleOnChange} />
          </Form.Field>                    
        </Form.Group>   
        <Form.Group widths={"equal"}>
          <Form.Field>
            <label>Identifier</label>
            <Input name="appleInputs.shippingMethods[0].identifier" value={appleInputs.shippingMethods[0].identifier} onChange={handleOnChange} />
          </Form.Field>
          <Form.Field>
            <label>Label</label>
            <Input name="appleInputs.shippingMethods[0].label" value={appleInputs.shippingMethods[0].label} onChange={handleOnChange} />
          </Form.Field>
        </Form.Group>             

        <Header as="h2">Button</Header>
        <Form.Group widths='equal'>
          <Form.Select fluid label="Color" options={srcApplePayButtonColorEnumsObj} name="applePayButtonParams.buttonColor" defaultValue={applepayInputs.applePayButtonParams.buttonColor} onChange={handleOnChange} />   
          <Form.Select fluid label="Type" options={srcApplePayButtonTypeEnumsObj} name="applePayButtonParams.buttonType" defaultValue={applepayInputs.applePayButtonParams.buttonType} onChange={handleOnChange} />
        </Form.Group>
      </Form>
    </React.Fragment>
  );
}